import styled from 'styled-components';

const FormWrapper = styled.div`
    margin-bottom: 1.875rem;
`;

export default FormWrapper;